export default {
  name: 'dashify:GridContainerWithReflow',
  title: 'Grid Container (with reflow)',
  owner: 'System',
  solution: '',
  tags: ['layouts', 'grid', 'reflow'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'dashify:CardWithTitle',
        { '.': 'border-white p-2', title: 'Grid Container (with reflow)' },
        'under construction...',
      ],
    ],
  },
};
